import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';
import { ListItem } from '../../../interfaces/list-item.interface';

@Component({
  selector: 'acl-general-popover',
  standalone: false,
  templateUrl: './general-popover.component.html',
  styleUrl: './general-popover.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralPopoverComponent {
  readonly _items = signal<ListItem[]>([]);

  @Input() set items(items: ListItem[]) {
    this._items.set(items);
  }
}
